import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Col, Table, Tooltip } from 'antd';
import IconNotFound from '../../../assets/Images/icons/empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import UserManagementService from '../../../services/UserManagement.service';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDelete from '../../../components/Shared/modal/delete';
import ModalSuccess from '../../../components/Shared/modal/success';
import ModalFail from '../../../components/Shared/modal/fail';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';
import IconFail from '../../../assets/Images/icons/icon-fail';
import usePermission from '../../../hooks/usePermission';

const DepartmentListPage = () => {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [openModalActionDelete, setOpenModalActionDelete] = useState(false);
    const [openModalStatusSuccess, setOpenModalStatusSuccess] = useState(false);
    const [openModalStatusFail, setOpenModalStatusFail] = useState(false);
    const [failTitle, setFailTitle] = useState();
    const [failtSubtitle, setFailtSubtitle] = useState();
    const [deleteId, setDeleteId] = useState();
    const [departmentName, setDepartmentName] = useState('');
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'modify_date',
        sortDirection: 'desc',
        total: 0,
    });
    const [searchValue, setSearchValue] = useState({
        departmentEn: '',
        departmentTh: '',
    });
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(0);

    useEffect(() => {
        if (loading === 0) {
            searchDepartment(searchValue, currentPage);
            setLoading(1);
        }
    }, [currentPage, loading, searchValue]);

    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isUser } = usePermission();

    const columns = [
        {
            title: 'No.',
            width: 30,
            render: (row, record, text) => {
                const numPage = currentPage.page - 1;
                const number = text + 1;
                const sum = numPage * 10;
                return <div>{number + sum}</div>;
            },
        },

        {
            title: t('userManagement.departmentEn'),
            dataIndex: 'departmentNameEn',
            key: 'department_en',
            sorter: () => null,
        },
        {
            title: t('userManagement.departmentTh'),
            dataIndex: 'departmentNameTh',
            key: 'department_th',

            sorter: () => null,
        },
        {
            title: t('userManagement.Member'),
            dataIndex: 'member',
            key: 'member',
            align: 'center',
            sorter: () => null,
        },
        {
            title: t('Action'),
            key: 'action',
            align: 'center',
            width: 200,
            hidden: isUser,
            render: (text, record) => (
                <span className="space-x-2">
                    <Tooltip
                        placement="bottom"
                        title={t('common.View')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            onClick={() =>
                                navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/view-department/${record.departmentId}`
                                )
                            }
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M23.47 15.83C22.882 14.3088 21.861 12.9933 20.5334 12.046C19.2058 11.0988 17.6298 10.5613 16 10.5C14.3703 10.5613 12.7942 11.0988 11.4666 12.046C10.139 12.9933 9.11811 14.3088 8.53003 15.83C8.49032 15.9399 8.49032 16.0601 8.53003 16.17C9.11811 17.6912 10.139 19.0067 11.4666 19.954C12.7942 20.9012 14.3703 21.4387 16 21.5C17.6298 21.4387 19.2058 20.9012 20.5334 19.954C21.861 19.0067 22.882 17.6912 23.47 16.17C23.5097 16.0601 23.5097 15.9399 23.47 15.83ZM16 19.25C15.3572 19.25 14.7289 19.0594 14.1944 18.7023C13.66 18.3452 13.2434 17.8376 12.9974 17.2437C12.7514 16.6499 12.6871 15.9964 12.8125 15.366C12.9379 14.7355 13.2474 14.1564 13.7019 13.7019C14.1565 13.2474 14.7355 12.9378 15.366 12.8124C15.9964 12.687 16.6499 12.7514 17.2438 12.9974C17.8376 13.2434 18.3452 13.6599 18.7023 14.1944C19.0594 14.7289 19.25 15.3572 19.25 16C19.2487 16.8615 18.9059 17.6874 18.2967 18.2966C17.6875 18.9058 16.8616 19.2487 16 19.25Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        title={t('Edit')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            hidden={!admin}
                            onClick={() =>
                                navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/edit-department/${record.departmentId}`
                                )
                            }
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M20.6586 9.34131L22.6586 11.3413L21.1339 12.8666L19.1339 10.8666L20.6586 9.34131ZM13.3333 18.6666H15.3333L20.1913 13.8086L18.1913 11.8086L13.3333 16.6666V18.6666Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        title={t('Delete')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            hidden={!admin}
                            onClick={() => {
                                setDeleteId(record.departmentId);
                                setOpenModalActionDelete(true);
                                setDepartmentName(
                                    i18n.language === 'en'
                                        ? record.departmentNameEn
                                        : record.departmentNameTh
                                );
                            }}
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>
                </span>
            ),
        },
    ].filter((item) => !item.hidden);

    const searchDepartment = (searchValue, pageValue) => {
        UserManagementService.searchUserDepartment({
            departmentEn: searchValue.departmentEn
                ? searchValue.departmentEn
                : '',
            departmentTh: searchValue.departmentTh
                ? searchValue.departmentTh
                : '',
            p: pageValue.page ? pageValue.page : 0,
            ps: pageValue.pageSize ? pageValue.pageSize : 10,
            s: pageValue.sortBy ? pageValue.sortBy : 'modify_date', //modify_date|department_th|department_en|member|
            sd: pageValue.sortDirection ? pageValue.sortDirection : 'desc',
        }).then((res) => {
            setData(res?.data?.resultData?.result || []);
            setCurrentPage({
                page: res?.data?.resultData.page,
                pageSize: res?.data?.resultData.pageSize,
                total: res?.data?.resultData.total,
            });
        });
    };

    const onSearch = async () => {
        const { getFieldsValue } = form;

        const searchValues = {
            departmentEn: getFieldsValue().departmentEn
                ? getFieldsValue().departmentEn
                : '',
            departmentTh: getFieldsValue().departmentTh
                ? getFieldsValue().departmentTh
                : '',
        };
        const search = {
            page: 1,
            pageSize: 10,
            sortBy: 'modify_date',
            sortDirection: 'desc',
            total: 0,
        };
        setSearchValue(searchValues);
        searchDepartment(searchValues, search);
    };
    const paginationProps = {
        current: parseInt(currentPage.page),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        // history.push(`${ROUTE.CHARGER_MANAGEMENT}/${pagination.current}`);
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'modify_date',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'desc',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        searchDepartment(searchValue, pageValues);
    };

    const ErrorMessage = (errors) => {
        setFailTitle(t('hasMemberTitle'));
        let sub = (textEn, text, lists = []) => (
            <div>
                <span>{i18n.language === 'en' ? textEn : text}</span>
                <ul className="bg-gray-100 mt-4 rounded-md text-sm text-left py-2 max-h-[150px] overflow-y-auto">
                    {lists.map((list) => (
                        <li key={list}>{list}</li>
                    ))}
                </ul>
            </div>
        );
        if (errors?.consentName?.length > 0) {
            const th =
                'พบว่าแผนกนี้ถูกเซ็ตไว้ใน Consent จึงไม่สามารถลบแผนกนี้ได้';
            const en =
                'Found that this department is set in Consent, so cannot delete this department.';
            setFailtSubtitle(sub(en, th, errors?.consentName));
        } else if (errors?.dataflow?.length > 0) {
            const th =
                'พบ Data Flow ถูกสร้างไว้ในแผนกนี้จึงไม่สามารถลบแผนกนี้ได้';
            const en =
                'Data Flow was found to be created in this department so this department cannot be deleted.';
            setFailtSubtitle(sub(en, th, errors?.dataflow));
        } else if (errors?.dataflowTab1?.length > 0) {
            const th =
                'พบว่าแผนกนี้ถูกระบุในเรื่องการเก็บรวบรวมข้อมูลของ Data Flow จึงไม่สามารถลบแผนกนี้ได้';
            const en =
                'It was found that this department was identified in Data Flow data collection, so cannot delete this department.';
            setFailtSubtitle(sub(en, th, errors?.dataflowTab1));
        } else if (errors?.requestId?.length > 0) {
            const th =
                'แผนกนี้มีงานที่ค้างอยู่ใน My Task - Data Subject 360 จึงไม่สามารถลบแผนกนี้ได้';
            const en =
                'This department has work pending in My Task - Data Subject 360, so cannot delete this department.';
            setFailtSubtitle(sub(en, th, errors?.requestId));
        } else if (errors?.riskRegisterNumber?.length > 0) {
            const th =
                'พบ Risk Register ถูกสร้างไว้ในแผนกนี้จึงไม่สามารถลบแผนกนี้ได้';
            const en =
                'Risk Register was found to be created in this department so this department cannot be deleted.';
            setFailtSubtitle(sub(en, th, errors?.riskRegisterNumber));
        } else if (errors?.workflowName?.length > 0) {
            const th =
                ' แผนกนี้ถูกเซ็ตไว้เป็นผู้รับผิดชอบใน Step การทำงาน (Data Subject 360) กรุณาตรวจสอบ';
            const en =
                'This department has been set to be responsible for the workflow step (Data Subject 360). Please check.';
            setFailtSubtitle(sub(en, th, errors?.workflowName));
        }
    };

    const handelDelete = () => {
        setOpenModalActionDelete(false);
        UserManagementService.deleteDepartment(deleteId)
            .then((res) => {
                if (res.data?.resultData) {
                    if (res.data.resultData?.departmentId) {
                        setOpenModalStatusSuccess(true);
                        const SearchValue = {
                            departmentEn: '',
                            departmentTh: '',
                        };
                        setSearchValue({
                            departmentEn: '',
                            departmentTh: '',
                        });
                        setCurrentPage({
                            page: 0,
                            pageSize: 10,
                            sortBy: 'departmentEn',
                            sortDirection: 'asc',
                        });
                        searchDepartment(SearchValue, currentPage);
                    } else {
                        ErrorMessage(res.data?.resultData);
                        setOpenModalStatusFail(true);
                    }
                }
            })
            .catch((err) => {
                const errCode = err.data.errorData.msg;
                if (errCode === 'FOUND MEMBERS, CANNOT DELETE DEPARTMENT') {
                    setTimeout(() => {
                        setFailTitle(t('hasMemberTitle'));
                        setFailtSubtitle(t('hasMemberBody'));
                        setOpenModalStatusFail(true);
                    }, 1000);
                } else {
                    setTimeout(() => {
                        setFailtSubtitle(t('common.FailedDeleteData'));
                        setOpenModalStatusFail(true);
                    }, 1000);
                }
            });
    };

    return (
        <div className="bg-gray-body">
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(ROUTER.CONFIGURATION.USER_MANAGEMENT)
                    }
                >
                    <IconBack />
                </button>
                {t('Department List')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('common.Configuration')} / {t('User Management')} /{' '}
                </span>
                <span> {t('Department List')}</span>
            </div>
            <div className="w-full  text-center m-auto">
                <div
                    className="content bg-white px-8 pt-8 pb-2 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="search pb-3">
                        <Row className="mb-1 -mt-2">
                            <label
                                style={{ fontSize: '20px', fontWeight: 500 }}
                            >
                                {t('Search Filter')}
                            </label>
                        </Row>
                        <Row>
                            <Form
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                }}
                                form={form}
                                layout="inline"
                                className="w-full"
                            >
                                <Row
                                    className="w-full flex-1 mb-2"
                                    gutter={[0, 8]}
                                >
                                    <Col>
                                        <Form.Item
                                            name="departmentEn"
                                            colon={false}
                                        >
                                            <Input
                                                size="large"
                                                className="rounded flex"
                                                placeholder={`${t(
                                                    'Department'
                                                )} (EN)`}
                                                style={{ width: 400 }}
                                                allowClear
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col>
                                        <Form.Item
                                            name="departmentTh"
                                            colon={false}
                                        >
                                            <Input
                                                size="large"
                                                className="rounded flex"
                                                placeholder={`${t(
                                                    'Department'
                                                )} (TH)`}
                                                style={{ width: 400 }}
                                                allowClear
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <div className="flex">
                                    <Col>
                                        <Button
                                            size="large"
                                            htmlType="submit"
                                            type="primary"
                                            onClick={onSearch}
                                            style={{
                                                marginRight: 10,
                                            }}
                                            icon={<SearchOutlined />}
                                        >
                                            {t('Search')}
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            size="large"
                                            className="py-0 px-3 mr-2 hover:opacity-80"
                                            style={{
                                                borderColor: '#65707A',
                                            }}
                                            type="primary"
                                            ghost
                                            onClick={() => {
                                                form.resetFields();

                                                const SearchValue = {
                                                    departmentEn: '',
                                                    departmentTh: '',
                                                };
                                                setSearchValue({
                                                    departmentEn: '',
                                                    departmentTh: '',
                                                });
                                                setCurrentPage({
                                                    page: 0,
                                                    pageSize: 10,
                                                    sortBy: 'departmentEn',
                                                    sortDirection: 'asc',
                                                });
                                                searchDepartment(
                                                    SearchValue,
                                                    currentPage
                                                );
                                            }}
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15 5.707L14.293 5L12 7.293L9.707 5L9 5.707L11.293 8L9 10.2925L9.7075 11L12 8.707L14.2935 11L15 10.2935L12.707 8L15 5.707Z"
                                                    fill="#65707A"
                                                />
                                                <path
                                                    d="M2 2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V4.585C0.999962 4.7164 1.02582 4.84651 1.07609 4.96791C1.12637 5.0893 1.20008 5.1996 1.293 5.2925L5 9V13C5 13.2652 5.10536 13.5196 5.29289 13.7071C5.48043 13.8946 5.73478 14 6 14H8C8.26522 14 8.51957 13.8946 8.70711 13.7071C8.89464 13.5196 9 13.2652 9 13V12H8V13H6V8.585L5.707 8.2925L2 4.5855V3H12V4H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H2Z"
                                                    fill="#65707A"
                                                />
                                            </svg>
                                        </Button>
                                    </Col>
                                </div>
                            </Form>
                        </Row>
                    </div>
                </div>

                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <div className="title ">
                                        {t('Department List')}
                                    </div>
                                </Row>
                                <Row>
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-400">
                                            {t('landing.DepartmentListDes')}
                                        </span>
                                    </div>
                                </Row>
                                <Row className="my-4">
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-500 font-semibold">
                                            {t('TotalItems', {
                                                length: currentPage.total,
                                            })}
                                        </span>
                                    </div>
                                </Row>
                            </Col>
                            <Col>
                                <Row
                                    style={{
                                        position: 'absolute',
                                        right: 0,
                                    }}
                                >
                                    {admin && (
                                        <div className="flex gap-2">
                                            <Button
                                                size="large"
                                                htmlType="submit"
                                                type="default"
                                                className="w-full text-[#7B67FB] border-[#7B67FB]"
                                                onClick={() =>
                                                    navigate(
                                                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/import-department`
                                                    )
                                                }
                                            >
                                                {t('Import Department')}
                                            </Button>

                                            <Button
                                                size="large"
                                                htmlType="submit"
                                                type="primary"
                                                className="w-full"
                                                onClick={() =>
                                                    navigate(
                                                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/add-department`
                                                    )
                                                }
                                            >
                                                {t('Add Department')}
                                            </Button>
                                        </div>
                                    )}
                                </Row>
                            </Col>
                        </Row>

                        <Table
                            locale={{ emptyText: <IconNotFound /> }}
                            className="inbox_table"
                            rowKey={(record) => record.id}
                            //loading={loading}
                            columns={columns}
                            dataSource={data}
                            pagination={paginationProps}
                            onChange={onPageChange}
                        />
                        <ModalDelete
                            open={openModalActionDelete}
                            text={t('modalDepartmentDelete', {
                                name: departmentName,
                            })}
                            handelOk={handelDelete}
                            handelClose={() => {
                                setOpenModalActionDelete(false);
                            }}
                        />
                        <ModalSuccess
                            open={openModalStatusSuccess}
                            handelClose={() => {
                                setOpenModalStatusSuccess(undefined);
                            }}
                            handelOk={() => {
                                setOpenModalStatusSuccess(undefined);
                            }}
                            text={t('common.SaveData')}
                        />
                        {failTitle === t('hasMemberTitle') ? (
                            <ModalFail
                                open={openModalStatusFail}
                                handelClose={() => {
                                    setOpenModalStatusFail(undefined);
                                }}
                                handelOk={() => {
                                    setOpenModalStatusFail(undefined);
                                }}
                                icon={<IconFail />}
                                title={failTitle}
                                text={failtSubtitle}
                            />
                        ) : (
                            <ModalFail
                                icon={<IconFail />}
                                open={openModalStatusFail}
                                handelClose={() => {
                                    setOpenModalStatusFail(undefined);
                                }}
                                handelOk={() => {
                                    setOpenModalStatusFail(undefined);
                                }}
                                text={failtSubtitle}
                            />
                        )}
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
    );
};

export default DepartmentListPage;
